import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ActionButton from '@components/common/ActionButton';

type ChecklistEmptyStateProps = {
  onAddItem: () => void;
};

export const ChecklistEmptyState: React.FC<ChecklistEmptyStateProps> = ({
  onAddItem
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '64px 24px',
        textAlign: 'center'
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '12px',
          backgroundColor:
            theme.palette.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.08)'
              : 'rgba(0, 0, 0, 0.04)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px'
        }}
      >
        <AddIcon
          sx={{
            fontSize: 24,
            color: 'text.disabled'
          }}
        />
      </Box>
      <Typography
        variant="h6"
        sx={{
          color: 'text.secondary',
          fontWeight: 400,
          marginBottom: '8px'
        }}
      >
        {t('checklist:empty.title')}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.disabled',
          marginBottom: '24px'
        }}
      >
        {t('checklist:empty.subtitle')}
      </Typography>
      <ActionButton startIcon={<AddIcon />} onClick={onAddItem}>
        {t('checklist:empty.addFirst')}
      </ActionButton>
    </Box>
  );
};
